import React from 'react'
import { StyledToggleButton } from './styled'

const ToggleButton = ({ children, ...resProps }) => (
	<StyledToggleButton {...resProps}>{children}</StyledToggleButton>
)

export default ToggleButton
